import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetScheduledTransactionPreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetScheduledTransactionPreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setScheduledTransactionPreference = (
  request: SetScheduledTransactionPreferenceRequest,
  options?: CashRequestOptions
) =>
  post<SetScheduledTransactionPreferenceRequest, SetScheduledTransactionPreferenceResponse>(
    '/2.0/cash/set-scheduled-transaction-preference',
    request,
    { ...options, rejectOnError: true }
  )
